document.addEventListener( 'DOMContentLoaded', function () {
  const socialLinks = document.querySelectorAll( '#microsite-social-links-wrapper .microsite-social-links li' );
  const socialMasks = document.querySelectorAll( '.e-div--social-mask' );

  if ( socialLinks && socialLinks.length > 4 ) {
    socialMasks.forEach( mask => mask.style.display = 'none' );
  }
} );